import { DefaultState } from '@src/redux/types'

import { CLUB_EVENT_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [CLUB_EVENT_LIST]: DefaultState<`${typeof API.CLUB_EVENT}`, 'get'>
} = () => ({
  [CLUB_EVENT_LIST]: defaultState(),
})
